export interface State {
  id: string;
  code: string;
  name_translations: {
    ar: string;
    en: string;
  };
}

export interface City {
  id: string;
  code: string;
  name_translations: {
    ar: string;
    en: string;
  };
  state_code?: string;
}

export interface DeliveryRateState {
  id: string;
  code: string;
  name: {
    ar: string;
    en: string;
  };
}

export interface DeliveryRateCity {
  id: string;
  code: string;
  name: {
    ar: string;
    en: string;
  };
}

export interface DeliveryRateServiceType {
  id: string;
  code: string;
  name: string;
}

export const DELIVERY_TYPE_LABELS: Record<string, string> = {
  same_day: 'نفس اليوم',
  next_day: 'اليوم التالي',
  scheduled: 'مجدول',
};
